import type { Question } from '@all-for-one/shared-types'

/* Turns a question into something worth listening to.
 *
 * Not just the question string: a child using read-aloud needs the options too,
 * each announced with its letter, or they cannot answer without reading the
 * screen anyway -- which defeats the point. The mockup does the same ("A. a
 * star", "B. a planet").
 *
 * Fill-blank carries its prompt as an array of fragments either side of each
 * blank, so the blanks are spoken as the word "blank" rather than the fragments
 * being run together into a sentence that doesn't parse aloud.
 */
export const questionSpeechText = (question: Question): string => {
	switch (question.type) {
		case 'multiple-choice': {
			const parts = [question.question]
			question.options.forEach((opt, i) => {
				parts.push(`${String.fromCharCode(65 + i)}. ${opt}`)
			})
			return parts.join('. ')
		}
		case 'fill-blank':
			return question.question.join(' blank ')
		case 'short-answer':
			return question.question
		default:
			return ''
	}
}
